module.exports = __webpack_public_path__ + "img/thumbnail_CoquerelsSifaka_j_normal.2fde7494.png";